import { render } from "./BaseButton.vue?vue&type=template&id=4af0aa13&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=4af0aa13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af0aa13"],['__file',"src/components/BaseButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4af0aa13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4af0aa13', __exports__)) {
    api.reload('4af0aa13', __exports__)
  }
  
  module.hot.accept("./BaseButton.vue?vue&type=template&id=4af0aa13&scoped=true", () => {
    api.rerender('4af0aa13', render)
  })

}


export default __exports__